export const normalizeStoredBlogSlug = (slug: unknown, lang?: string): string => {
    const segments = String(slug || '').split('/').filter(Boolean);

    if (segments[0] === 'blog') {
        segments.shift();
    }
    if (lang && lang !== 'en' && segments[0] === lang) {
        segments.shift();
    }

    return segments.join('/');
};

export const getArticlePath = (article: any, currentLang?: string): string => {
    const articleLang = currentLang || article?.lang || 'en';
    const slug = normalizeStoredBlogSlug(article?.slug, articleLang);
    const prefix = articleLang !== 'en' ? `/${articleLang}` : '';

    return `${prefix}/blog/${slug}`;
};

export const getArticleUrl = (article: any, currentLang?: string): string => (
    `https://traffic-creator.com${getArticlePath(article, currentLang)}`
);
